module.exports = __webpack_public_path__ + "assets/img/poster-employment_02.063b4870.jpg";